import { HttpClient, HttpParams } from '@angular/common/http'

import { ExchangeRate } from '@app/features/scope-overview/model/exchange-rate.model'
import { ExchangeRateFilter } from '@core/model/exchange-rate-filter.model'
import { Injectable } from '@angular/core'
import { Page } from '@app/features/scoping/models/page.model'
import { Pagination } from '@core/model/definitions/pagination.interface'
import { environment } from '@envs/environment'

@Injectable({ providedIn: 'root' })
export class ExchangeRateService {
  private readonly BASE_API_URL: string = environment.scopeApiUrl
  exchangeRate: ExchangeRate

  constructor(private http: HttpClient) {}

  get selectedCurrency() {
    return this.exchangeRate?.toCurrencyCode
  }

  getExchangeRates(filter: ExchangeRateFilter, pageInfo: Pagination) {
    const httpParams = new HttpParams().set('page', pageInfo.page).set('pageSize', pageInfo.pageSize)

    return this.http.post<Page<ExchangeRate>>(`${this.BASE_API_URL}company/exchange-rates`, filter, {
      params: httpParams,
    })
  }

  addExchangeRate(exchangeRate: any) {
    return this.http.post<any>(`${this.BASE_API_URL}company/exchange-rate`, exchangeRate)
  }

  editExchangeRate(exchangeRate: any) {
    return this.http.put<any>(`${this.BASE_API_URL}company/exchange-rate/${exchangeRate.id}`, exchangeRate)
  }

  deleteExchangeRate(exchangeRateId: number) {
    return this.http.delete(`${this.BASE_API_URL}company/exchange-rate/${exchangeRateId}`)
  }

  getExchangeRatesForSourceCurrency(currencyCode) {
    return this.http.get<any>(`${this.BASE_API_URL}company/exchange-rates?currencyCode=${currencyCode}&direction=FROM`)
  }
}
